import { memo } from 'react';
import cn from 'classnames';
import { ICluster } from 'src/interface';
import { ObjectUtils } from 'src/utils';
import RouterLink from 'src/components/links';

export function ContentCluster({
    cluster,
    className = '',
}: {
    cluster: ICluster;
    className?: string;
}) {
    if (ObjectUtils.isEmpty(cluster) || cluster.total < 1) {
        return null;
    }

    return (
        <RouterLink to={cluster.url} className={cn("related", className)}>
            <span>{cluster.total} liên quan</span>
        </RouterLink>
    );
}

export default memo(ContentCluster);
